import _classCallCheck from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/editorui/boxed/boxededitoruiview
 */
import EditorUIView from '../../editorui/editoruiview';
import LabelView from '../../label/labelview';
/**
 * The boxed editor UI view class. This class represents an editor interface
 * consisting of a toolbar and an editable area, enclosed within a box.
 *
 * @extends module:ui/editorui/editoruiview~EditorUIView
 */

var BoxedEditorUIView = /*#__PURE__*/function (_EditorUIView) {
  _inherits(BoxedEditorUIView, _EditorUIView);

  var _super = _createSuper(BoxedEditorUIView);

  /**
   * Creates an instance of the boxed editor UI view class.
   *
   * @param {module:utils/locale~Locale} locale The locale instance..
   */
  function BoxedEditorUIView(locale) {
    var _this;

    _classCallCheck(this, BoxedEditorUIView);

    _this = _super.call(this, locale);
    /**
     * Collection of the child views located in the top (`.ck-editor__top`)
     * area of the UI.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.top = _this.createCollection();
    /**
     * Collection of the child views located in the main (`.ck-editor__main`)
     * area of the UI.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.main = _this.createCollection();
    /**
     * Voice label of the UI.
     *
     * @protected
     * @readonly
     * @member {module:ui/view~View} #_voiceLabelView
     */

    _this._voiceLabelView = _this._createVoiceLabel();

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-reset', 'ck-editor', 'ck-rounded-corners'],
        role: 'application',
        dir: locale.uiLanguageDirection,
        lang: locale.uiLanguage,
        'aria-labelledby': _this._voiceLabelView.id
      },
      children: [_this._voiceLabelView, {
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-editor__top', 'ck-reset_all'],
          role: 'presentation'
        },
        children: _this.top
      }, {
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-editor__main'],
          role: 'presentation'
        },
        children: _this.main
      }]
    });

    return _this;
  }
  /**
   * Creates a voice label view instance.
   *
   * @private
   * @returns {module:ui/label/labelview~LabelView}
   */


  _createClass(BoxedEditorUIView, [{
    key: "_createVoiceLabel",
    value: function _createVoiceLabel() {
      var t = this.t;
      var voiceLabel = new LabelView();
      voiceLabel.text = t('Rich Text Editor');
      voiceLabel.extendTemplate({
        attributes: {
          class: 'ck-voice-label'
        }
      });
      return voiceLabel;
    }
  }]);

  return BoxedEditorUIView;
}(EditorUIView);

export { BoxedEditorUIView as default };